import React, { useMemo, useState } from "react";
import { setCurrentValuation } from "../../redux/valuations.slice";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useSpring, animated } from "react-spring";
import useDeviceType from "../../utils/useDeviceType";
import routes from "../../routing/routes";
import { QrReader } from "react-qr-reader";
import LoadingDots from "../../components/LoadingDots";
import Button from "../../components/Button";
import {
  MonsterIcon,
  MonsterRedIcon,
  WhiteCircleCloseIcon
} from "../../assets/icons";
import clsx from "clsx";

const PageContent = ({ type, setIsBottomSheetOpen, setIsValModalOpen }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isScanning, setIsScanning] = useState(false);
  const [succScanned, setSuccScanned] = useState(false);
  const { valuations, currentValuation, valuationLoading } = useSelector(
    (store) => store.valuationsDetails
  );
  const { isMobileView, isDesktopView } = useDeviceType();

  const isMultipleValuations = useMemo(() => {
    return valuations && Object.keys(valuations).length > 1;
  }, [valuations]);

  const animation = useSpring({
    opacity: isScanning ? 1 : 0,
    from: { opacity: 0 },
    config: { duration: 100 }
  });

  const handleGoToStart = () => {
    dispatch(setCurrentValuation(undefined));
    navigate("/" + routes["root"].children["default"].path);
  };

  const handleOnResult = (result) => {
    if (!!result) {
      setSuccScanned(true);
      window.location.replace(result.text);
    }
  };

  switch (type) {
    case "error":
      return (
        <>
          <img
            src={MonsterRedIcon}
            alt="monster-icon"
            className="mx-auto mt-[13%] mb-8"
          />
          <div className="page-title text-center mb-3">
            {t("error-page.title")}
          </div>
          <div className="page-subtitle text-center">
            {t("error-page.subtitle")}
          </div>

          <div className="mt-2 mx-auto mb-12 space-y-4">
            {isMultipleValuations && (
              <>
                <div
                  className={clsx(
                    "bg-accumin-neutral-100 page-subtitle text-center mt-2  mx-auto p-2 rounded-lg"
                  )}
                  onClick={() => {
                    if (isMultipleValuations && !valuationLoading) {
                      if (isMobileView) {
                        setIsBottomSheetOpen(true);
                      } else if (isDesktopView) {
                        setIsValModalOpen(true);
                      }
                    }
                  }}
                >
                  {`${valuations[currentValuation].basicValuation?.street}, ${valuations[currentValuation].basicValuation?.streetNumber}`}
                </div>
                <div className="flex items-center text-sm">
                  <div className="delimiter flex-grow"></div>
                  <div className="px-2 text-accumin-neutral-400">
                    {t("sign-in.or")}
                  </div>
                  <div className="delimiter flex-grow"></div>
                </div>
              </>
            )}
            <Button
              type="submit"
              className="mb-12 py-4 px-6 w-fit mx-auto"
              onClick={handleGoToStart}
            >
              {t("labels.back-to-dashboard")}
            </Button>
          </div>
        </>
      );

    case "not-found":
      return (
        <>
          <img
            src={MonsterIcon}
            alt="monster-red-icon"
            className="mx-auto mt-auto mb-8"
          />
          <div className="page-title text-center mb-3">
            {t("error-page.page-not-found-title")}
          </div>
          <div className="page-subtitle text-center">
            {t("error-page.page-not-found-subtitle")}
          </div>
          <Button
            type="submit"
            className="mt-auto mx-auto mb-12 py-4 px-6 w-fit"
            onClick={() => setIsScanning(true)}
          >
            {t("labels.scan-qr-code")}
          </Button>

          {isScanning && (
            <animated.div
              className="modal-fullscreen bg-black"
              style={animation}
            >
              <WhiteCircleCloseIcon
                onClick={() => setIsScanning(false)}
                className="shrink-0"
              />
              <div className="my-auto">
                {succScanned ? (
                  <LoadingDots />
                ) : (
                  <QrReader
                    constraints={{ facingMode: "environment" }}
                    delay={3000}
                    onResult={handleOnResult}
                    style={{ width: "100%" }}
                  />
                )}
              </div>
            </animated.div>
          )}
        </>
      );

    default:
      return <></>;
  }
};

export default PageContent;
